import styled from 'styled-components';
import { Box } from '@mui/material';
import COLORS from '@app/colors';

export const MainLayer = styled(Box)({
  paddingTop: '20px',
  marginTop: '20px',
  borderTop: `1px solid ${COLORS.border}`
});

export const ContentWrapper = styled(Box)({
  gap: '30px',

  '.images-wrapper > div': {
    display: 'flex'
  }
});

export const VisuallyHiddenInput = styled('input')({
  clip: 'rect(0 0 0 0)',
  clipPath: 'inset(50%)',
  height: 1,
  overflow: 'hidden',
  position: 'absolute',
  bottom: 0,
  left: 0,
  whiteSpace: 'nowrap',
  width: 1,
});

export const StyledImage = styled('img')({
  width: '300px',
  height: '200px',
  objectFit: 'cover',
});
